import { Row, Col, Panel, ButtonToolbar, Notification, useToaster , Drawer, Button } from "rsuite"
import { Icon } from '@rsuite/icons';
import SettingIcon from '@rsuite/icons/Setting';
import FunnelIcon from '@rsuite/icons/Funnel';
import * as linkIcon from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';

import BriefCreateForm from "./briefCreateForm";
import { clearPreviousEdit } from "./briefLocalStorageManager";
import { useEffect, useState } from "react";
import useLocalStorage from "../../hooks/useLocalStorage";
import BriefDrawerFooter from "./briefDrawerFooter";

const FaSvgIcon = ({ faIcon, ...rest }) => {
    const { width, height, svgPathData } = faIcon;
    return (
      <svg {...rest} viewBox={`0 0 ${width} ${height}`} width="1em" height="1em" fill={rest.color}>
        <path d={svgPathData}></path>
      </svg>
    );
  }

export default function BriefCreateDrawer({open, setOpen, updateBriefs}) {
    return (
        <Drawer className="brief-create-drawer" open={open} onClose={() => {
            clearPreviousEdit();
            setOpen(false);
        }} size="md">
            <Drawer.Header>
                <Drawer.Title>Создание брифа</Drawer.Title>
                <Drawer.Actions>
                    <BriefDrawerFooter setOpen={setOpen} updateBriefs={updateBriefs}/>
                </Drawer.Actions>
            </Drawer.Header>
            <Drawer.Body style={{maxHeight: 'none'}}>
                <BriefCreateForm />
            </Drawer.Body>
        </Drawer>
    )
}